export const withCompInfo = () => (depsArray, resolver) => {
    const deps = depsArray.reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: true })), {});
    return {
        deps,
        resolver,
    };
};
export const withStateRefs = () => (depsArray, resolver) => {
    const refApiKey = 'refApi';
    const deps = [...depsArray, refApiKey];
    const withCompInfoFunc = withCompInfo();
    return withCompInfoFunc(deps, resolver);
};
export function createComponentMapperModel(mapper) {
    return mapper;
}
//# sourceMappingURL=createComponentMapper.js.map